import { TextLink } from '@airwallex/typography';
import styled from '@emotion/styled';
import { CSSProperties } from 'react';

export const lineItemsCellContainerStyle: CSSProperties = {
  justifyContent: 'center',
  minWidth: 0,
  width: '100%',
  whiteSpace: 'normal',
  overflowWrap: 'break-word',
  wordBreak: 'break-word',
};

export const lineItemsShowMoreButton = styled(TextLink)`
  display: inline-block;
  &:hover {
    text-decoration: none;
  }
`;

export function lineItemsTableSharedCss(showMoreButtonShown: boolean): string {
  return `
  margin-bottom: 16px;
  & table {
    table-layout: fixed;
    width: 100%;
  }
  & th:first-of-type,
  & td:first-of-type {
    min-width: 0;
    white-space: normal;
    overflow-wrap: break-word;
    word-break: break-word;
    vertical-align: top;
  }
  ${
    showMoreButtonShown
      ? `
    & tbody > tr:nth-last-child(2) > td {
      border-bottom: none !important;
    }
    & tbody > tr:last-child > td {
      height: 56px;
      padding-block: 0;
    }
    & tbody > tr:last-child > td > span {
      min-height: unset;
    }
  `
      : ''
  }
  & td:has([data-row-type='discount']) > div {
    display: none;
  }
  & tfoot {
    display: none;
  }
`;
}
